import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homethree-main-banner',
  templateUrl: './homethree-main-banner.component.html',
  styleUrls: ['./homethree-main-banner.component.scss']
})
export class HomethreeMainBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
